(() => {
  const init = root => {
    if (root.dataset.ready) return;
    const q = selector => root.querySelector(selector);
    const qa = selector => [...root.querySelectorAll(selector)];
    const library = qa('[data-scent-profile]');
    const products = [...root.closest('.tsg-story').querySelectorAll('[data-tsg-catalog] template')];
    const moods = qa('[data-atmosphere]');
    const formatButtons = qa('[data-choose-format]');
    if (!library.length || !formatButtons.length) return;
    const profiles = library.map(template => ({
      key: template.dataset.scentProfile,
      name: template.content.querySelector('[data-name]').textContent.trim(),
      descriptor: template.content.querySelector('[data-descriptor]').textContent.trim(),
      body: template.content.querySelector('[data-body]').textContent.trim(),
      notes: template.content.querySelector('[data-notes]').textContent.trim(),
      search: template.content.querySelector('[data-search]')?.textContent.trim() || '',
      associations: template.content.querySelector('[data-associations]')?.textContent.trim() || ''
    }));
    const byKey = new Map(profiles.map(profile => [profile.key, profile]));
    const {groups, tokens, fillers, indexProfiles, searchRank} = window.TrudonScent;
    const offerings = (key, format) => products.filter(template => (!key || template.dataset.scent === key) && (!format || template.dataset.format === format));
    indexProfiles(profiles);
    const label = format => formatButtons.find(button => button.dataset.chooseFormat === format).querySelector('.tse-format-name').textContent.trim();
    const make = (tag, className, text) => { const element = document.createElement(tag); element.className = className; element.textContent = text; return element; };
    let atmosphere = 'fresh', selected = null, format = null;
    const moveTo = (section, focus) => {
      const target = q(focus || section);
      if (target) target.focus({preventScroll: true});
      q(section).scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
    };
    const announce = () => {
      q('[data-journey-status]').textContent = `${root.dataset.announcement} ${selected.name}${format ? ` · ${label(format)}` : ''}.`;
    };
    const updateScentStates = () => qa('[data-select-scent]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.selectScent === selected?.key)));
    const renderFormat = next => {
      format = next;
      const hasProducts = offerings(selected.key, format);
      formatButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.chooseFormat === format)));
      q('[data-format-title]').textContent = label(format);
      q('[data-format-body]').replaceChildren(q(`[data-format-description="${format}"]`).content.cloneNode(true));
      q('[data-selection-title]').textContent = `${selected.name} · ${label(format)}`;
      q('[data-promeneuse-object]').hidden = format !== 'promeneuse';
      q('[data-cameo-note]').hidden = format !== 'promeneuse' || !hasProducts.length;
      q('[data-product-options]').replaceChildren(...hasProducts.map(template => template.content.cloneNode(true)));
      q('[data-tax]').hidden = !hasProducts.length;
      q('[data-format-alternatives]').hidden = !!hasProducts.length;
      const alternatives = q('[data-alternative-scents]');
      alternatives.replaceChildren();
      if (!hasProducts.length) {
        const keys = [...new Set(offerings(null, format).map(template => template.dataset.scent))].filter(key => byKey.has(key));
        keys.sort((a, b) => byKey.get(a).name.localeCompare(byKey.get(b).name));
        keys.forEach(key => {
          const button = make('button', 'tse-alternative', byKey.get(key).name);
          button.type = 'button'; button.dataset.alternativeScent = key;
          button.addEventListener('click', () => {
            const group = Object.keys(groups).find(group => groups[group].includes(key)) || 'all';
            setAtmosphere(group, false, false);
            selectScent(byKey.get(key), true);
            moveTo('#tse-format-panel','[data-format-title]');
          });
          alternatives.append(button);
        });
        q('[data-no-format]').hidden = keys.length > 0;
      }
      q('#tse-format-panel').hidden = false;
      announce();
    };
    const selectScent = (profile, keepFormat = false) => {
      selected = profile;
      q('#tse-profile-title').textContent = profile.name;
      q('[data-profile-descriptor]').textContent = profile.descriptor;
      q('[data-profile-body]').textContent = profile.body;
      q('[data-profile-notes]').textContent = profile.notes;
      const group = atmosphere !== 'all' && groups[atmosphere].includes(profile.key) ? atmosphere : Object.keys(groups).find(group => groups[group].includes(profile.key));
      q('[data-profile-moment]').textContent = moods.find(button => button.dataset.atmosphere === group)?.dataset.moment || '';
      q('[data-current-fragrance]').textContent = profile.name;
      q('#tse-profile').hidden = false;
      updateScentStates();
      formatButtons.forEach(button => {
        const available = offerings(profile.key, button.dataset.chooseFormat).length > 0;
        button.dataset.available = String(available);
        button.querySelector('[data-format-status]').textContent = available ? root.dataset.available : root.dataset.unavailable;
      });
      const next = keepFormat && format ? format : formatButtons.find(button => offerings(profile.key, button.dataset.chooseFormat).length)?.dataset.chooseFormat || formatButtons[0].dataset.chooseFormat;
      renderFormat(next);
    };
    const pool = () => {
      const candidates = atmosphere === 'all' ? [...profiles].sort((a,b) => a.name.localeCompare(b.name)) : groups[atmosphere].map(key => byKey.get(key)).filter(profile => profile && offerings(profile.key).length);
      const words = atmosphere === 'all' ? tokens(q('#tse-search').value).filter(word => !fillers.has(word)) : [];
      if (!words.length) return candidates;
      const ranked = partial => candidates.map(profile => ({profile, score: searchRank(profile, words, partial)})).filter(match => match.score > 0).sort((a,b) => b.score - a.score || a.profile.name.localeCompare(b.profile.name)).map(match => match.profile);
      const exact = ranked(false);
      return exact.length ? exact : ranked(true);
    };
    const renderScents = () => {
      const candidates = pool();
      const list = q('[data-scent-list]'); list.replaceChildren();
      candidates.forEach(profile => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'tse-scent'; button.dataset.selectScent = profile.key;
        button.setAttribute('aria-pressed', String(profile.key === selected?.key)); button.setAttribute('aria-controls', 'tse-profile');
        button.append(make('span','tse-scent-name',profile.name), make('span','tse-scent-description',profile.descriptor));
        const mark = make('span','tse-scent-mark',''); mark.setAttribute('aria-hidden','true'); mark.append(q('.tse-choice-mark svg').cloneNode(true)); button.append(mark);
        if (!offerings(profile.key).length) button.append(make('span','tse-stock',q('[data-unavailable-label]').content.textContent));
        button.addEventListener('click', () => { selectScent(profile); moveTo('#tse-profile','#tse-profile-title'); });
        list.append(button);
      });
      q('[data-scent-count]').textContent = `${root.dataset.count}: ${candidates.length}`;
      q('[data-no-matches]').hidden = candidates.length > 0;
      q('[data-clear-search]').hidden = !q('#tse-search').value;
    };
    const setAtmosphere = (next, navigate = true, chooseFirst = true) => {
      atmosphere = next;
      const all = next === 'all';
      moods.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.atmosphere === next)));
      q('[data-all-scents]').setAttribute('aria-pressed', String(all));
      q('.tse-search').hidden = !all;
      q('#tse-search').value = '';
      const mood = moods.find(button => button.dataset.atmosphere === next);
      q('[data-pool-title]').textContent = all ? q('[data-all-title]').content.textContent : mood.querySelector('.tse-mood-title').textContent;
      q('[data-pool-description]').textContent = all ? q('[data-all-body]').content.textContent : mood.dataset.description;
      renderScents();
      const candidates = pool();
      if (chooseFirst && candidates.length) {
        const nextProfile = candidates.find(profile => profile.key === selected?.key) || candidates[0];
        selectScent(nextProfile, nextProfile.key === selected?.key);
      }
      if (navigate) moveTo('#tse-fragrances', all ? '#tse-search' : '#tse-fragrances-title');
    };
    moods.forEach(button => button.addEventListener('click', () => setAtmosphere(button.dataset.atmosphere)));
    q('[data-all-scents]').addEventListener('click', () => setAtmosphere('all'));
    q('#tse-search').addEventListener('input', renderScents);
    q('[data-clear-search]').addEventListener('click', () => {q('#tse-search').value = ''; renderScents(); q('#tse-search').focus();});
    formatButtons.forEach(button => button.addEventListener('click', () => { if (!selected) return; renderFormat(button.dataset.chooseFormat); moveTo('#tse-format-panel','[data-format-title]'); }));
    setAtmosphere('fresh', false);
    if (!selected && profiles.length) selectScent(profiles[0]);
    const requested = new URLSearchParams(window.location.search).get('scent');
    if (byKey.has(requested)) {setAtmosphere('all', false, false);selectScent(byKey.get(requested));}
    q('.tse-interactive').hidden = false;
    root.dataset.ready = 'true';
  };
  const start = () => document.querySelectorAll('[data-scent-guide]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
